import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Message } from 'semantic-ui-react';
import { OSMMap } from 'volto-venue';
import { Icon } from 'iovisit-theme/components';
import { RichText } from 'iovisit-theme/components/Views';

const messages = defineMessages({
  default_title: {
    id: 'ContactsBlock_defaultTitle',
    defaultMessage: 'Contatti',
  },
});

const Body = ({ data, properties, isEditMode }) => {
  const intl = useIntl();
  const title = data?.title
    ? data.title
    : intl.formatMessage(messages.default_title);

  const content = properties;
  if (!content) return;

  const moreContacts = RichText({
    content: content.further_info,
  });

  const latitude = content?.geolocation?.latitude ?? 0;
  const longitude = content?.geolocation?.longitude ?? 0;
  let hasGeolocationData =
    (latitude && latitude !== 0) || (longitude && longitude !== 0) || false;

  let hasData =
    content.street ||
    content.zip_code ||
    content.city ||
    content.country ||
    hasGeolocationData ||
    content.phone?.length > 0 ||
    content.fax ||
    content.email ||
    content.external_link ||
    moreContacts;

  return !hasData ? (
    isEditMode ? (
      <Message size="mini">
        Geolocalizzazione: Nessun dato da mostrare.
        <br />
        Questo blocco non verrà mostrato in visualizzazione.
      </Message>
    ) : null
  ) : (
    <div className="block contacts">
      <div className="contacts-data-wrapper">
        <div className="contacts-data">
          <h2>{title}</h2>
          {(content.street ||
            content.zip_code ||
            content.city ||
            content.country) && (
            <p>
              {content.street && content.street + ' '}
              {content.street && content.zip_code && '- '}
              {content.zip_code && content.zip_code + ' '}
              {content.city && content.city + ' '}
              {content.country && <>({content.country})</>}
            </p>
          )}

          {(content.phone?.length > 0 ||
            content.fax?.length > 0 ||
            content.email?.length > 0) && (
            <p>
              {content.phone?.length > 0 && (
                <>
                  Tel.{' '}
                  {content.phone.map((p, i) => (
                    <>
                      {i > 0 && <br />}
                      <a href={`tel:${p}`}>{p}</a>
                    </>
                  ))}
                  <br />
                </>
              )}
              {content.fax?.length > 0 && (
                <>
                  Fax <a href={`fax:${content.fax}`}>{content.fax}</a>
                  <br />
                </>
              )}
              {content.email?.length > 0 && (
                <>
                  <a href={`mailto:${content.email}`}>{content.email}</a>
                  <br />
                </>
              )}
            </p>
          )}

          {content.external_link && (
            <p>
              <a href={content.external_link} target="_blank" rel="noreferrer">
                <Icon prefix="fas" icon="external-link-alt" className="icon" />{' '}
                {content.link_title ?? content.external_link}
              </a>
            </p>
          )}

          {moreContacts && moreContacts}
        </div>
        <div className="geolocation-map">
          {__CLIENT__ && hasGeolocationData && (
            <OSMMap
              center={[latitude, longitude]}
              markers={[{ ...content.geolocation, title: content.title }]}
              showTooltip
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default Body;
